import React, { useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';
import { ThemeContext } from '../../../../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { closeAllPrositions } from '../../../../api/request/dashboard/dashboard';

export default function DeleteConfirmationModal({ open, onCancel, onConfirm, selectedRows = [], activeContextRow = null, activeRowId = null, filteredData =[], setDeleteConfirmOpen, setActiveContextRow = () => {}, setSelectedRows = () => {}, setActiveRowId = () => {} }) {
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()
    
    const getConfirmationText = () => {
        if (selectedRows?.length > 0) {
            return t('confirmCloseSelected');
        } else if (activeContextRow ) {
            const side = activeContextRow?.side === 1 ? t('buy') : t('sell');
            return t('confirmCloseAllPositions', {
                side,
                symbolName: activeContextRow.symbolName
            });
        } else {
            return t('confirmCloseRow');
        }
    };
    const handleConfirmDelete = async () => {
        let rowsToClose = [];

        if (selectedRows?.length > 0) {
            rowsToClose = selectedRows;
        } else if (activeContextRow) {
            rowsToClose = [activeContextRow];
        } else if (activeRowId) {
            const row = filteredData.find((row) => row.id === activeRowId);
            if (row) rowsToClose = [row];
        }

        const orders = rowsToClose.flatMap(row =>
            row.positionList.map(pos => ({
                accountId: pos.accountId,
                amount: pos.amount,
                positionId: pos.id,
            }))
        );

        if (!orders.length) return;

        try {
            await closeAllPrositions({ orders });
            toast.success("Positions closed successfully");
        } catch (err) {
            console.error(err);
            toast.error("Failed to close positions");
        } finally {
            setDeleteConfirmOpen(false);
            setActiveContextRow(null);
            setSelectedRows([]);
            setActiveRowId(null);
        }
    };

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ color: "white", p: 1 }} className="bg-primary">
                <Typography variant="body1" sx={{ color: darkMode ? "var(--white)" : "var(--white)" }} align="center">
                    {t('confirmation')}
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5" }}>
                <Typography sx={{ fontSize: 14, pt: 2 }}>{getConfirmationText()}</Typography>
            </DialogContent>
            <DialogActions sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5" }}>
                <Button onClick={onCancel} variant="outlined">{t('no')}</Button>
                <Button onClick={handleConfirmDelete} variant="contained" color="error">{t('yes')}</Button>
            </DialogActions>
        </Dialog>
    );
}
